import React from 'react'

const SbDriveScoring = () => {
  return (
    <button
  onClick={() => {
    const link = document.createElement("a");
    link.href = "/Documents/Solidarty_DC_Scoring_20250518_1-[IPPE].xlsx"; // relative to public/
    link.download = "SBDriveScoring.xlsx"; // file name when downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
>
  Download Scoring Sheet
</button>

  )
}

export default SbDriveScoring;
